import _extends from "@babel/runtime/helpers/esm/extends";
import { useGridAriaAttributes as useGridAriaAttributesCommunity } from '@mui/x-data-grid/internals';
import { useGridRootProps } from "./useGridRootProps.mjs";
export const useGridAriaAttributesPro = () => {
  const ariaAttributesCommunity = useGridAriaAttributesCommunity();
  const rootProps = useGridRootProps();
  const ariaAttributesPro = rootProps.treeData ? {
    role: 'treegrid'
  } : {};
  return _extends({}, ariaAttributesCommunity, ariaAttributesPro);
};